import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    // Skip on language switch (marker set by Header)
    if (window.__zx_langSwitch) {
      window.__zx_langSwitch = false;
      return;
    }
    // If a hash is present, let the target page scroll to that section
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
